import React, {useState, useEffect, useRef} from 'react';
import { useNavigate } from 'react-router';
import { useStateValue } from '../../stateProvider/stateProvider';
import { USER,ADMIN } from '../../constans/roles';
import './Creation.css'

import {
    FilterSelect
} from '../Filter/Filter';
import { SET_EDIT_ID } from '../../constans/reducerActions';
import Button from '../../components/Button/Button';

export const CreationSchema = ({
    click,
    clear,
    clips,
    setClips,
    setClear,
    filtersData
}) => {
    const [{role},dispatch] = useStateValue();
    console.log('fs', filtersData)

    const handleGetClips = () => {
        let clipIt = ""


        clips.forEach(item => {
            console.log(item.txt)

            console.log(item.ref.current)
            item.ref(false);
            clipIt += item.txt + " \n"
        })

        setClips([])
        
        navigator.clipboard.writeText(clipIt)
    }

    return (
        <tr className="creation__wrap panel-table__header">
            <td className='rel-small'></td>
            <td className='rel'>

            <FilterSelect 
                title='Kampania' 
                val="Kampania" 
                filtr={click}
                opts={filtersData.Kampania} 
                clear={clear} 
                setClear={setClear}>    
            </FilterSelect>
            </td>
            <td className='rel'>
            <FilterSelect 
             filtr={click}
                title='Klient' 
                val="Klient" 
                opts={filtersData.Klient}  
                clear={clear} 
                setClear={setClear}>    
            </FilterSelect>
            </td>
            <td className='rel'>
            <FilterSelect 
             filtr={click}
                title='Format' 
                val="Format" 
                opts={filtersData.Format} 
                clear={clear} 
                setClear={setClear}>    
            </FilterSelect>
            </td>
            <td className='rel'>


            <FilterSelect 
             filtr={click}
                title='Branża' 
                val="Kategoria" 
                opts={filtersData.Kategoria} 
                clear={clear} 
                setClear={setClear}>    
            </FilterSelect>
            </td>
 
            <td className='td-link'>
            <h3 className='filter__title creation-header__center-column-txt'>Link</h3>
            </td>
            <td className='rel-small'>
               <h3 className='filter__title creation-header__center-column-txt'>Kopiuj link</h3>
            </td>
            {
                (role === USER || role === ADMIN) &&
                <td className='rel-small'>
                    <h3 className='filter__title creation-header__center-column-txt'>Edytuj</h3>
                </td>
            }
            {
                role === ADMIN &&
                <td className='rel-small'>
                    <h3 className='filter__title creation-header__center-column-txt'>Usuń</h3>
                </td>
            }
           
                <td className='rel-small'>
                    <h3 className='filter__title creation-header__center-column-txt clip-clap' onClick={handleGetClips}>Kopiuj zaznaczone</h3>
                </td>
            

            <td className='rel-small'></td>
        </tr>
    )
}


const Creation = ({clipId,clips,setClips, item,click}) => {
    const [{role},dispatch] = useStateValue()
    const [checked,setChecked] = useState(false) 

    const handleCopy = e => {
        navigator.clipboard.writeText(item.Link)
    }
    
    const edit = () => {
        dispatch({type:SET_EDIT_ID,item:item._id})
        document.querySelector('.edit-fixed').style.display = "block"
    }

    const handleOnChange = (e) => {
        if(e.target.checked){
            setClips( clips.filter(item => item.id != e.target.value))
            setChecked(false)
        } else {
            const txtToClip = item.Format + " | " + item.Klient + ' - ' + item.Kampania + ": " + item.Link
            setClips(clips => [...clips,{txt:txtToClip, id:e.target.value, ref: setChecked}])
            setChecked(true)

        }
       
    }

    return (
        <tr className="creation__wrap">
          <td className='rel-small'></td>

            <td className="rel">
                {item.Kampania}
            </td>
            <td className="rel">
                {item.Klient}
            </td>
            <td className="rel">
                {item.Format}
            </td>
            <td className="rel">
                {item.Kategoria}
            </td>

            <td className='td-link'>
               <a target="_blank" href={item.Link}>{item.Link}</a>
            </td>
            <td className='rel-small height-med-btn' >
            <Button 
                      txt="Kopiuj link"
                      click={handleCopy}
                      styles = {{
                        minWidth:'120px',
                        fontWeight: 'var(--highlight-font-weight)',
                        textTransform: 'none',
                        backgroundColor: 'black',
                        margin: '10px',
                        padding: '0px 20px',
                        minHeight: '40px',
                      }}
                />
            </td>
            {
                (role === USER || role === ADMIN) && 
                <Button 
                      txt="Edytuj"
                      click={edit}
                      styles = {{
                        minWidth:'120px',
                        fontWeight: 'var(--highlight-font-weight)',
                        textTransform: 'none',
                        backgroundColor: 'black',
                        margin: '15px',
                        padding: '0px 20px',
                        minHeight: '40px',
                      }}
                />
            }
            {
                role === ADMIN&&
                <td className="rel-small height-med-btn">
                <Button 
                      txt="Usuń"
                      click={click}
                      styles = {{
                        minWidth:'120px',
                        fontWeight: 'var(--highlight-font-weight)',
                        textTransform: 'none',
                        backgroundColor: 'red',
                        margin: '10px',
                        padding: '0px 20px',
                        minHeight: '40px',
                      }}
                />
                </td>
            }

          
                <td className="rel-small height-med-btn ">
                    <input 
                        type='checkbox' 
                        className={'data-grid-row__checbox-un-ch ' + (checked ? 'data-grid-row__checbox-ch' : '')} 
                        checked={ checked} 
                        onInput={ handleOnChange} 
                        value={clipId} 
                        
                    />
                </td>
            

            <td className='rel-small'></td>
        </tr>
    )
}

export default Creation
// + (cliped && 'Clicked')